import {
  SectionContainer,
  SectionInner,
} from "components/rhombus-UI/theme/containers";
import React from "react";
import { EventContainer } from "./styles/rctp-styles";
import TrainingEvent from "./TrainingEvent";
import useGetRctpEvents from "./hooks/useGetRctpEvents";
import { TitleMed } from "components/rui/typography";
import NotFound from "components/common/NotFound";

export default function TrainingEventFeed() {
  const events = useGetRctpEvents();

  return (
    <SectionContainer style={{ overflow: "unset" }}>
      <SectionInner>
        <EventContainer>
          {!events || events.length === 0 ? (
            <NotFound errorMessage={"No Upcoming RCTP Events"} />
          ) : (
            events?.map(event => (
              <TrainingEvent eventData={event} key={event.node.id} />
            ))
          )}
        </EventContainer>
      </SectionInner>
    </SectionContainer>
  );
}
